import { Directive, ElementRef, HostListener, Renderer2 } from "@angular/core";

@Directive({
  selector: "[dragScroll]"
})
export class DragScrollDirective {
  private isPointerDown = false;
  private startClientX = 0;
  private startClientY = 0;
  private startScrollLeft = 0;
  private startScrollTop = 0;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  @HostListener("mousedown", ["$event"]) onMouseDown(event: MouseEvent): void {
    if (event.button !== 0) {
      return;
    }
    this.isPointerDown = true;
    this.startClientX = event.clientX;
    this.startClientY = event.clientY;
    this.startScrollLeft = this.el.nativeElement.scrollLeft;
    this.startScrollTop = this.el.nativeElement.scrollTop;
    this.renderer.setStyle(this.el.nativeElement, "cursor", "grabbing");
    this.renderer.setStyle(this.el.nativeElement, "user-select", "none");
  }

  @HostListener("document:mouseup") onMouseUp(): void {
    if (!this.isPointerDown) {
      return;
    }
    this.isPointerDown = false;
    this.renderer.removeStyle(this.el.nativeElement, "cursor");
    this.renderer.removeStyle(this.el.nativeElement, "user-select");
  }

  @HostListener("mouseleave") onMouseLeave(): void {
    if (!this.isPointerDown) {
      return;
    }
    this.isPointerDown = false;
    this.renderer.removeStyle(this.el.nativeElement, "cursor");
    this.renderer.removeStyle(this.el.nativeElement, "user-select");
  }

  @HostListener("mousemove", ["$event"]) onMouseMove(event: MouseEvent): void {
    if (!this.isPointerDown) {
      return;
    }
    event.preventDefault();
    const deltaX = event.clientX - this.startClientX;
    const deltaY = event.clientY - this.startClientY;
    this.el.nativeElement.scrollLeft = this.startScrollLeft - deltaX;
    this.el.nativeElement.scrollTop = this.startScrollTop - deltaY;
  }
}
